import { Injectable } from '@angular/core';
import { URLS } from '../constants/constants';
import { HeaderType } from '../enums/enums';
import { FilterModel } from '../interface/interface';
import { AuthorPayloadModel } from '../models/author.model';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorService {
  constructor(private http: HttpService) {}

  fetchAuthors(filter?: FilterModel) {
    return this.http.get(URLS.author, {
      params: {
        headerType: HeaderType.ACCESS,
        ...(filter
          ? {
              search: filter.searchText,
              page: filter.pageNumber,
              limit: filter.limit,
            }
          : {}),
      },
    });
  }

  addAuthor(payload: AuthorPayloadModel) {
    return this.http.post(`${URLS.author}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  updateAuthor(id: string, payload: AuthorPayloadModel) {
    return this.http.put(`${URLS.author}/${id}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  deleteAuthor(id: string) {
    return this.http.delete(`${URLS.author}/${id}`, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  fetchAuthorById(id: string) {
    return this.http.get(`${URLS.author}/${id}`, {
      params: {
        headerType: HeaderType.ACCESS,
      },
    });
  }
}
